
const tokenKey = 'auth';
let tokenTmp =sessionStorage.getItem(tokenKey);
export const tokenStorage = (val = null) => {
  if (val || val !== null) {
    tokenTmp = val || '';
    if (!tokenTmp) {
      sessionStorage.removeItem(tokenKey)
    } else {
       sessionStorage.setItem(tokenKey, tokenTmp)
    }
  }
  return tokenTmp;
};
